import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

type MarketingSection = {
  id: string;
  title: string;
  body: string;
};

type RelatedLink = {
  label: string;
  to: string;
};

type MarketingArticleProps = {
  title: string;
  lede: string;
  sections: MarketingSection[];
  relatedLinks?: RelatedLink[];
  children?: ReactNode;
};

export function MarketingArticle({ title, lede, sections, relatedLinks, children }: MarketingArticleProps) {
  return (
    <article className="blog-content blog-content--wide">
      <h1 className="font-display text-[clamp(34px,4vw,54px)] leading-[0.95] tracking-[-0.02em] text-[#f2efea] m-0">
        {title}
      </h1>
      <p className="mt-6 text-[17px] leading-[1.65] text-on-surface sm:text-[18px] [text-wrap:pretty] max-w-3xl">
        {lede}
      </p>
      <div className="mt-10 space-y-8 text-[15px] leading-[1.8] text-on-surface-variant sm:text-[16px] max-w-3xl">
        {sections.map((section) => (
          <section key={section.id} id={section.id} className="scroll-mt-24">
            <h2 className="mkt-section-title text-[24px] leading-tight tracking-[-0.01em] text-on-surface m-0 mb-3">
              {section.title}
            </h2>
            <p className="m-0 text-on-surface-variant">{section.body}</p>
          </section>
        ))}
      </div>
      {children && <div className="mt-10 flex flex-wrap items-center gap-3 border-t border-white/10 pt-8 max-w-3xl">{children}</div>}
      {relatedLinks && relatedLinks.length > 0 && (
        <nav className="mt-10 border-t border-white/10 pt-6 flex flex-wrap gap-x-4 gap-y-2 max-w-3xl">
          {relatedLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="font-mono text-[11px] tracking-[0.16em] uppercase text-primary hover:text-[#ffcfbf]"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      )}
    </article>
  );
}
